import { useState, useEffect } from 'react';
import { FaTimes, FaRocket } from 'react-icons/fa';
import styles from './onboarding.module.css';

const DebateOnboarding = ({ onStartDebate, onClose }) => {
    return (
        <div className={styles.overlay} onClick={onClose}>
            <div className={styles.modal} onClick={e => e.stopPropagation()}>
                <button className={styles.closeBtn} onClick={onClose} aria-label="Fermer">
                    <FaTimes />
                </button>
                
                <div className={styles.imageWrapper}>
                    <img src="/assets/onboarding.png" alt="Bienvenue sur Agora" className={styles.img} />
                </div>
                
                <div className={styles.content}>
                    <h2 className={styles.title}>Exprimez-vous avec impact ! ⚖️</h2>
                    <p className={styles.description}>
                        Bienvenue dans la nouvelle ère d'Agora. Désormais, chaque idée est un débat. 
                        Donnez votre avis, opposez vos arguments et voyez qui vous suit !
                    </p>
                    
                    <ul className={styles.features}>
                        <li>🤝 <strong>Échangez</strong> sur des sujets d'actualité</li>
                        <li>🌓 <strong>Sides</strong> : Choisissez votre camp (Pour ou Contre)</li>
                        <li>💬 <strong>Arguments</strong> : Publiez des preuves et des images</li>
                    </ul>

                    <button className={styles.cta} onClick={() => { onStartDebate(); onClose(); }}>
                        <span>Lancer mon premier débat</span>
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DebateOnboarding;
